module.exports = __webpack_public_path__ + "static/media/more.e1852906.svg";